<template>
  <div class="layout-center-wrap">
    <div class="page-tit__wrap type-center">
      <h1 class="page-tit__sub" v-if="memberInfo.role === 'REPORT'">
        신고자(민간 보안 전문가)
      </h1>
      <h1 class="page-tit__sub" v-else>제조사 담당자</h1>
      <h2 class="page-tit">마이페이지</h2>
    </div>
    <h3 class="section-title" v-if="isMemberVerify">개인 정보 입력</h3>
    <h3 class="section-title" v-else>개인 정보 확인</h3>

    <table class="board-write type-block--mobile" v-if="isMemberVerify">
      <tbody>
        <tr v-if="memberInfo.role === 'PATCH'">
          <th scope="row">
            제조사<span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="pw" class="sr-only">제조사 입력</label>
            <span>{{ memberInfo.makrName }}</span>
          </td>
        </tr>
        <tr>
          <th scope="row">아이디</th>
          <td>
            <label for="id" class="sr-only">아이디</label>
            <span>{{ memberInfo.userId }}</span>
          </td>
        </tr>
        <tr>
          <th scope="row">비밀번호</th>
          <td>
            <button
              type="button"
              class="btn btn--blue"
              :class="isPasswordChange ? 'btn--gray' : 'btn--blue'"
              v-on:click="isPasswordChange = !isPasswordChange"
            >
              {{
                isPasswordChange ? "비밀번호 재설정 취소" : "비밀번호 재설정"
              }}
            </button>
          </td>
        </tr>
        <tr v-if="isPasswordChange">
          <th scope="row" class="th--blue">현재 비밀번호</th>
          <td>
            <label for="currentPassword" class="sr-only"
              >현재 비밀번호 입력</label
            >
            <input
              type="password"
              id="currentPassword"
              class="board-write__input"
              v-model="password.currentPassword"
            />
          </td>
        </tr>
        <tr v-if="isPasswordChange">
          <th scope="row" class="th--blue">신규 비밀번호</th>
          <td>
            <label for="newPassword" class="sr-only">신규 비밀번호 입력</label>
            <input
              type="password"
              id="newPassword"
              class="board-write__input"
              v-model="password.newPassword"
            />
          </td>
        </tr>
        <tr v-if="isPasswordChange">
          <th scope="row" class="th--blue">신규 비밀번호 확인</th>
          <td>
            <label for="checkPassword" class="sr-only"
              >신규 비밀번호 확인 입력</label
            >
            <input
              type="password"
              id="checkPassword"
              class="board-write__input"
              v-model="password.checkPassword"
            />
          </td>
        </tr>
        <tr>
          <th scope="row">이름</th>
          <td>
            <label for="name" class="sr-only">이름 입력</label>
            <span>{{ memberInfo.userName }}</span>
          </td>
        </tr>
        <tr>
          <th scope="row">영문 이름</th>
          <td>
            <label for="e-name" class="sr-only">영문 이름 </label>
            <input
              type="text"
              id="e-name"
              class="board-write__input"
              v-model="memberInfo.userEngName"
            />
          </td>
        </tr>
        <tr>
          <th scope="row">휴대전화 번호</th>
          <td>
            <label for="tel" class="sr-only">휴대전화 번호 입력</label>
            <span>{{ memberInfo.phone }}</span>
          </td>
        </tr>
        <tr>
          <th scope="row">이메일</th>
          <td>
            <label for="email" class="sr-only">이메일 입력</label>
            <input
              type="text"
              id="email"
              class="board-write__input"
              v-model="memberInfo.email"
            />
          </td>
        </tr>
        <tr>
          <th scope="row">소속</th>
          <td>
            <label for="affiliation" class="sr-only">소속 입력</label>
            <input
              type="text"
              id="affiliation"
              class="board-write__input"
              v-model="memberInfo.userGroup"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <table class="board-write type-block--mobile" v-else>
      <tbody>
        <tr>
          <th scope="row">비밀번호 확인</th>
          <td>
            <label for="id" class="sr-only">비밀번호 확인</label>
            <input
              type="password"
              id="id"
              class="board-write__input"
              v-model="verifyPassword"
              @keyup.enter="verifyMember"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <fieldset
      class="section-pt"
      v-if="isMemberVerify && memberInfo.role === 'REPORT'"
    >
      <section class="agree__form">
        <article class="agree__container">
          <div class="agree__body terms__container">
            <p class="terms-tit">
              개인정보 수집·이용 동의
              <span class="sub">(선택)</span>
            </p>
            <p class="terms-content">
              - 수집·이용 목적 : 신고포상제 명예의 전당 등록<br />
            </p>
            - 수집·이용 항목 : 성명, 닉네임, 웹사이트 주소<br />
            - 보유·이용 기간 : 회원탈퇴 후 6개월 간 보관<br />
            - 동의 거부에 따른 불이익 : 동의를 거부할 수 있으나, 이 경우 명예의
            전당 등록이 제한됩니다.  
          </div>
          <div class="agree__footer">
            <p class="agree-label">개인정보 수집·이용에 동의합니다.</p>
            <div class="chk__wrap">
              <label class="chk chk--circle"
                ><input
                  type="radio"
                  name="agree2"
                  :value="false"
                  v-model="memberInfo.hasHonorRegit"
                  v-on:click="initHonorInfo"
                />동의안함</label
              >
              <label class="chk chk--circle"
                ><input
                  type="radio"
                  name="agree2"
                  :value="true"
                  v-model="memberInfo.hasHonorRegit"
                />동의함</label
              >
            </div>
          </div>
          <div class="agree__footer" v-if="memberInfo.hasHonorRegit">
            <table class="board-write type-block--mobile">
              <tbody>
                <tr>
                  <th scope="row" class="th--blue">
                    닉네임<span
                      class="svg_icon icon_must"
                      aria-hidden="true"
                    ></span
                    ><span class="sr-only">필수입력</span>
                  </th>
                  <td>
                    <div class="layout-flex-row">
                      <label for="nickname" class="sr-only">닉네임 입력</label>
                      <input
                        type="text"
                        id="nickname"
                        class="board-write__input"
                        v-on:change="
                          memberInfo.userNickname != originalNickname
                            ? (isNickNameDuplicate = false)
                            : (isNickNameDuplicate = true)
                        "
                        v-model="memberInfo.userNickname"
                      />
                      <button
                        type="button"
                        class="btn btn--m"
                        :class="
                          isNickNameDuplicate ? 'btn--gray' : 'btn--medium_blue'
                        "
                        v-on:click="checkNickNameDuplicate"
                      >
                        중복확인
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row" class="th--blue">웹사이트</th>
                  <td>
                    <label for="web" class="sr-only">웹사이트 입력</label>
                    <input
                      type="text"
                      id="web"
                      class="board-write__input"
                      v-model="memberInfo.userWebsite"
                      maxlength="200"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </article>
      </section>
    </fieldset>
    <div class="btn__wrap type-bottom-board" style="position: relative">
      <button
        v-if="isMemberVerify"
        type="button"
        class="btn btn--m btn--blue btn--m_full"
        v-on:click="setMemberInfo"
      >
        수정
      </button>
      <button
        v-else
        type="button"
        class="btn btn--l btn--blue btn--m_full"
        v-on:click="verifyMember"
      >
        확인
      </button>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { inject, ref, onMounted, watch } from "vue";
import { useStore } from "vuex";

import Auth from "../member/Auth.vue";
import dc from "@/component/DataChk.js";
import gt from "@/component/GetTokenValue.js";
import rsa from "@/component/RSAPublicKey.js";

export default {
  components: {
    Auth,
  },
  setup() {
    const axios = inject("axios");
    const lodash = inject("lodash");
    const router = useRouter();
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const defaultmemberInfo = () => ({
      role: gt.getRole(),
      userId: "",
      userPw: "",
      userName: "",
      userEngName: "",
      userNickname: "",
      userWebsite: "",
      phone: "",
      email: "",
      userGroup: "",
      hasChild: false,
      hasHonorRegit: false,
      makrCode: null,
      makrName: null,
      hasPasswordChange: false,
      currentPassword: "",
      newPassword: "",
      checkPassword: "",
    });
    const password = ref({
      currentPassword: "",
      newPassword: "",
      checkPassword: "",
    });
    const isNickNameDuplicate = ref(true);
    const memberInfo = ref(defaultmemberInfo());
    const makrCodes = ref([]);
    const isPasswordChange = ref(false);
    const isMemberVerify = ref(false);
    const verifyPassword = ref(null);
    const originalNickname = ref("");
    const originalInfo = ref(null);

    // methods 정의

    const checkNickNameDuplicate = () => {
      if (memberInfo.value.userNickname === originalNickname.value) {
        isNickNameDuplicate.value = true;
        alert("기존 닉네임과 동일합니다.");
        return;
      }

      isNickNameDuplicate.value = false;
      if (!dc.nullChk(memberInfo.value.userNickname)) {
        alert("닉네임을 입력하십시오.");
        return;
      }
      showLoading();
      axios
        .post("/core/pu/member/nickname-vaild/get", {
          userNickname: memberInfo.value.userNickname,
        })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            alert("사용 가능한 닉네임입니다.");
            isNickNameDuplicate.value = true;
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const initHonorInfo = () => {
      memberInfo.value.userNickname = "";
      memberInfo.value.userWebsite = "";
      isNickNameDuplicate.value = false;
    };

    const validateMemberInfo = () => {
      if (memberInfo.value.hasHonorRegit) {
        if (!dc.nullChk(memberInfo.value.userNickname)) {
          alert(
            "개인정보 수집·이용 동의 (선택) 항목에 동의 시, 신고포상제 명예의 전당 등록을 위해 닉네임을 입력하여 주십시오."
          );
          return false;
        } else {
          if (!isNickNameDuplicate.value) {
            alert(
              "신고포상제 명예의 전당 등록을 위해 닉네임 중복체크를 진행해 주십시오."
            );
            return false;
          }
        }
      }

      if (isPasswordChange.value) {
        if (!dc.nullChk(password.value.currentPassword)) {
          alert("현재 비밀번호를 입력하십시오");
          return false;
        } else if (!dc.nullChk(password.value.newPassword)) {
          alert("신규 비밀번호를 입력하십시오");
          return false;
        } else if (!dc.nullChk(password.value.checkPassword)) {
          alert("신규 비밀번호 확인을 입력하십시오");
          return false;
        } else if (!dc.passwordCheck(password.value.newPassword)) {
          alert(
            `비밀번호는 숫자, 영문, 특수문자를 1개이상 8~20자리 이내로 입력하십시오.`
          );
          return false;
        } else if (
          password.value.newPassword !== password.value.checkPassword
        ) {
          alert("입력하신 비밀번호와 비밀번호 확인이 일치하지 않습니다.");
          return false;
        }
      }

      if (!dc.nullChk(memberInfo.value.userEngName)) {
        alert("영문 이름을 입력하십시오");
        return false;
      }

      if (!dc.nullChk(memberInfo.value.email)) {
        alert("이메일을 입력하십시오");
        return false;
      } else if (!dc.emailValidChk(memberInfo.value.email)) {
        alert("이메일을 정확하게 입력하십시오.\n입력예시) korea@kisa.co.kr");
        return false;
      }

      return true;
    };

    const encrptyMemberInfo = (info) => {
      info.userId = "";
      info.verifyPassword = rsa.encryptData(verifyPassword.value);

      info.hasPasswordChange = isPasswordChange.value;
      info.currentPassword = rsa.encryptData(password.value.currentPassword);
      info.newPassword = rsa.encryptData(password.value.newPassword);
      info.checkPassword = rsa.encryptData(password.value.checkPassword);
      info.email = rsa.encryptData(info.email);
    };

    const setMemberInfo = () => {
      if (!validateMemberInfo()) {
        return;
      }

      if (!dc.chkOnlyEng(memberInfo.value.userEngName)) {
        alert("영문 이름은 영문자만 입력 가능합니다.");
        return;
      }

      const info = lodash.cloneDeep(memberInfo.value);
      if (lodash.isEqual(originalInfo.value, info) && !isPasswordChange.value) {
        alert("수정 사항이 없습니다. 개인정보 수정 후 요청해주세요");
        return; // 서버 요청 안함
      }

      showLoading();
      //암호화
      encrptyMemberInfo(info);

      axios
        .post("/core/pr/member/set", info)
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            alert("개인정보 수정이 완료되었습니다.");
            isPasswordChange.value = false;
            password.value = {
              currentPassword: "",
              newPassword: "",
              checkPassword: "",
            };
            originalInfo.value = lodash.cloneDeep(memberInfo.value);
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const getMemberInfo = () => {
      showLoading();
      axios
        .post(`/core/pr/member/get`, {
          verifyPassword: rsa.encryptData(verifyPassword.value),
        })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            originalNickname.value = res.data.resList[0].userNickname;
            memberInfo.value = res.data.resList[0];
            originalInfo.value = lodash.cloneDeep(memberInfo.value);
          } else {
            alert(res.data.resMsg);
            // router.push("/");
          }
        })
        .catch((error) => {
          console.error(error);
          router.push("/");
        })
        .finally(() => {
          hideLoading();
        });
    };
    const getMakrCodes = () => {
      axios
        .post("/core/pu/code/makr-codes/get", { depth: 1 })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            makrCodes.value = res.data.resList;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };

    const verifyMember = () => {
      if (!dc.nullChk(verifyPassword.value)) {
        alert("비밀번호를 확인하신 후 마이페이지를 조회하실 수 있습니다.");
        return;
      }

      showLoading();
      axios
        .post("/core/pr/member/verify", {
          password: rsa.encryptData(verifyPassword.value),
        })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            isMemberVerify.value = true;
            getMemberInfo();
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    // life cycle 정의
    onMounted(() => {
      if (!dc.nullChk(gt.getUser())) {
        router.push("/");
      }
      if (memberInfo.value.role === "PATCH") {
        getMakrCodes();
      }

      rsa.getPublicKey();
    });

    // html에서 사용될 데이터 정의
    return {
      memberInfo,
      isNickNameDuplicate,
      checkNickNameDuplicate,
      initHonorInfo,
      makrCodes,
      isPasswordChange,
      password,
      setMemberInfo,
      isMemberVerify,
      verifyMember,
      verifyPassword,
    };
  },
};
</script>